import { UnitChoices } from '../../enums';
import { MailingKind, NotificationPreferenceType } from '../me';
import mockedRequester from './mockedRequester';
export const mockedMe = {
    id: 1,
    joinedAt: '1610720198',
    email: 'email@email.fr',
    firstName: 'firstName',
    lastName: 'lastName',
    isEmailVerified: true,
    isStaff: true,
    isSuperuser: true,
    lastSeen: '1610720198'
};
export const mockedSendFcmToken = {
    name: 'Foo',
    os: 'iOs',
    deviceId: '869708',
    fcmToken: 'GIuhogz8Y9U0I'
};
export const mockedMyProfile = {
    hasAcceptedTermsOfService: true,
    hasAcceptedPolicyPrivacy: true,
    isSubscribedToNewsletter: true,
    language: 'fr',
    favoriteOrgId: 1,
    units: {
        T: UnitChoices.Temperature.celsiusDegrees,
        T_CAL: UnitChoices.Temperature.celsiusDegrees,
        T_DRY: UnitChoices.Temperature.celsiusDegrees,
        T_WET: UnitChoices.Temperature.celsiusDegrees,
        T_SOIL: UnitChoices.Temperature.celsiusDegrees,
        TX: UnitChoices.Temperature.celsiusDegrees,
        TN: UnitChoices.Temperature.celsiusDegrees,
        FF: UnitChoices.Speed.kilometersPerHour,
        FXY: UnitChoices.Speed.kilometersPerHour,
        U: UnitChoices.Humidity.percents,
        RR: UnitChoices.Length.millimeters,
        HPOT: UnitChoices.Pressure.kiloPascals,
        LW_V: UnitChoices.Voltage.millivolts,
        IRR: UnitChoices.Length.millimeters,
        etp: UnitChoices.Length.millimeters,
        SACC: UnitChoices.Acceleration.metersPerSecondSquare,
        DD: UnitChoices.Angle.degrees,
        DXY: UnitChoices.Angle.degrees,
        SLAT: UnitChoices.Angle.degrees,
        SLON: UnitChoices.Angle.degrees,
        VOLT: UnitChoices.Voltage.volts,
        U_CAPA: UnitChoices.Percent.percent,
        T_CAPA: UnitChoices.Temperature.celsiusDegrees,
        SSI: UnitChoices.SurfacePowerDensity.wattsPerSquareMeter
    }
};
const myInfo = { subscriptions: { essential: 0, plus: 1, expert: 1 } };
const notificationPreferences = [
    { type: NotificationPreferenceType.Device, channels: [0, 2], activated: false },
    { type: NotificationPreferenceType.Measure, channels: [2, 0], activated: true },
    { type: NotificationPreferenceType.OrgAdmin, channels: [2, 0], activated: false },
    { type: NotificationPreferenceType.DSS, channels: [2, 0], activated: true }
];
const primaryPhoneNumber = {
    id: 0,
    countryCode: 'FR',
    isEnabled: true,
    isPrimary: true,
    number: '0699999999',
    userId: 0
};
const secondaryPhoneNumber = {
    id: 1,
    countryCode: 'FR',
    isEnabled: false,
    isPrimary: false,
    number: '0611111111',
    userId: 0
};
const mailingPreferencesUnsubscribe = {
    token: '46g468geF5678Gfgzlaq',
    mailings: [MailingKind.newsLetter]
};
const mock = {
    get: mockedRequester(mockedMe, 'me.get'),
    getMyProfile: mockedRequester(mockedMyProfile, 'me.getMyProfile'),
    getMyInfo: mockedRequester(myInfo, 'me.getMyInfo'),
    updateMyProfile: mockedRequester(mockedMyProfile, 'me.updateMyProfile'),
    sendFcmToken: mockedRequester(mockedSendFcmToken, 'me.sendFcmToken'),
    acceptTermsOfService: mockedRequester(undefined, 'me.acceptTermOfService'),
    acceptPrivacyPolicy: mockedRequester(undefined, 'me.acceptePolicyPrivacy'),
    update: mockedRequester(mockedMe, 'me.update'),
    deleteMyAccount: mockedRequester(undefined, 'me.deleteMyAccount'),
    notificationPreferences: {
        getAll: mockedRequester(notificationPreferences, 'me.notificationPreferences.getAll'),
        get: mockedRequester(notificationPreferences[0], 'me.notificationPreferences.get'),
        edit: mockedRequester(notificationPreferences[0], 'me.notificationPreferences.edit'),
        replace: mockedRequester(notificationPreferences[0], 'me.notificationPreferences.replace')
    },
    mailingPreferences: {
        unsubscribe: mockedRequester(mailingPreferencesUnsubscribe, 'me.mailingPreferences.unsubscribe')
    },
    phoneNumbers: {
        getAll: mockedRequester([primaryPhoneNumber, secondaryPhoneNumber], 'me.phoneNumbers.getAll'),
        delete: mockedRequester(undefined, 'me.phoneNumbers.delete'),
        updateAll: mockedRequester([primaryPhoneNumber, secondaryPhoneNumber], 'me.phoneNumbers.updateAll'),
        enable: mockedRequester(primaryPhoneNumber, 'me.phoneNumbers.enable')
    }
};
export default mock;
